import { MediaElement } from 'editor/src/store/design/types';

export const GEOMETRY_KEYS = [
  'x',
  'y',
  'width',
  'height',
  'r',
  'px',
  'py',
  'pw',
  'ph',
  'pr',
  'x1',
  'y1',
  'x2',
  'y2',
] as const;

export const isNonFiniteNumber = (value: unknown) => typeof value === 'number' && !Number.isFinite(value);

// Finite numbers, and numeric strings that Preflight accepts as well.
export const isUsableNumber = (value: unknown) =>
  typeof value === 'string' ? value.trim() !== '' && Number.isFinite(Number(value)) : Number.isFinite(value);

// A NaN or Infinity that reaches the store is saved by the host as `null`
// (JSON.stringify), and Preflight then rejects every render of the design, as
// it does for a `null` or non-numeric value dispatched directly. Dropping the
// key keeps the element's last valid value instead.
function dropNonFiniteGeometry<T extends Partial<MediaElement>>(update: T): T {
  const record = update as Record<string, unknown>;
  const invalidKeys = GEOMETRY_KEYS.filter(
    (key) => key in record && record[key] !== undefined && !isUsableNumber(record[key]),
  );
  if (!invalidKeys.length) {
    return update;
  }

  const sanitized = { ...record };
  invalidKeys.forEach((key) => delete sanitized[key]);
  return sanitized as T;
}

export default dropNonFiniteGeometry;
